import React from "react";
import { useNavigate } from "react-router-dom";

const TermsAndConditions = () => {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-[#0B1C3F] flex items-center justify-center px-4 py-12">
      <div className="w-full max-w-7xl bg-white backdrop-blur-md shadow-2xl rounded-3xl border border-white/30 px-8 py-10 md:px-16 md:py-14">
        {/* Header */}
        <header className="mb-10 border-b border-slate-200 pb-4">
          <h1 className="text-3xl md:text-4xl font-bold text-blue-900">
            Terms &amp; Conditions
          </h1>
          <p className="mt-2 text-sm text-slate-600">
            Last updated:{" "}
            <span className="font-semibold text-slate-800">
              27 November 2025
            </span>
          </p>
        </header>

        {/* Content */}
        <main className="space-y-8 text-base text-slate-700 leading-relaxed max-h-[70vh] overflow-y-auto pr-2">
          {/* Intro */}
          <section>
            <p>
              Welcome to{" "}
              <span className="font-medium text-blue-900">
                Web_Bocket Classes
              </span>
              . By accessing or using our website, you agree to be bound by
              these Terms &amp; Conditions. If you do not agree with any part of
              the terms, you may not access the service.
            </p>
          </section>

          {/* 1. Use of the Service */}
          <section>
            <h2 className="text-xl font-semibold text-blue-900 mb-2">
              1. Use of the Service
            </h2>
            <p className="mb-2">
              You agree to use this website only for lawful purposes and in a
              way that does not:
            </p>
            <ul className="list-disc list-inside space-y-1 ml-3">
              <li>
                Violate any applicable local, national, or international law.
              </li>
              <li>Infringe the rights of any other person or company.</li>
              <li>Disrupt or interfere with the website or its security.</li>
            </ul>
          </section>

          {/* 2. Accounts */}
          <section>
            <h2 className="text-xl font-semibold text-blue-900 mb-2">
              2. Accounts &amp; Security
            </h2>
            <p className="mb-2">
              When you create an account with us, you must provide accurate and
              complete information. You are responsible for:
            </p>
            <ul className="list-disc list-inside space-y-1 ml-3">
              <li>
                Maintaining the confidentiality of your login credentials.
              </li>
              <li>All activities that occur under your account.</li>
            </ul>
            <p className="mt-2">
              If you believe your account has been compromised, please contact
              us immediately.
            </p>
          </section>

          {/* 3. Content Ownership */}
          <section>
            <h2 className="text-xl font-semibold text-blue-900 mb-2">
              3. Content Ownership
            </h2>
            <p>
              All content, design, logos, and other materials on this website
              are owned by
              <span className="font-medium"> Web_Bocket Classes</span> or its
              licensors, unless otherwise stated. You may not copy, reproduce,
              or distribute any content without our prior written permission.
            </p>
          </section>

          {/* 4. Third Party Links */}
          <section>
            <h2 className="text-xl font-semibold text-blue-900 mb-2">
              4. Third-Party Links
            </h2>
            <p>
              Our website may contain links to third-party websites or services
              that are not owned or controlled by us. We have no control over,
              and assume no responsibility for, the content, privacy policies,
              or practices of any third-party sites or services.
            </p>
          </section>

          {/* 5. Limitation of Liability */}
          <section>
            <h2 className="text-xl font-semibold text-blue-900 mb-2">
              5. Limitation of Liability
            </h2>
            <p>
              To the maximum extent permitted by law, we shall not be liable for
              any indirect, incidental, special, or consequential damages
              arising out of or in connection with your use of the website or
              services.
            </p>
          </section>

          {/* 6. Changes to Terms */}
          <section>
            <h2 className="text-xl font-semibold text-blue-900 mb-2">
              6. Changes to These Terms
            </h2>
            <p>
              We may update these Terms &amp; Conditions from time to time. Any
              changes will be effective when posted on this page. Your continued
              use of the website after changes are posted means you accept the
              updated terms.
            </p>
          </section>

          {/* Contact */}
          <section>
            <h2 className="text-xl font-semibold text-blue-900 mb-2">
              7. Contact Us
            </h2>
            <p>
              If you have any questions about these Terms &amp; Conditions, you
              can contact us at:
            </p>
            <p className="mt-1">
              Email:{" "}
              <a
                href="mailto:classeswebbocket@gmail.com"
                className="text-blue-700 hover:underline"
              >
                classeswebbocket@gmail.com
              </a>
            </p>
          </section>
        </main>

        {/* Footer */}
        <footer className="mt-10 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
          <p className="text-xs text-slate-600">
            By continuing to use this website, you agree to these Terms &amp;
            Conditions.
          </p>
          <button
            type="button"
            className="bg-blue-900 hover:bg-blue-800 text-white text-sm font-medium px-6 py-2 rounded-full shadow-md transition"
            onClick={() => {
              navigate("/");
              window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
            }}
          >
            Got It
          </button>
        </footer>
      </div>
    </div>
  );
};

export default TermsAndConditions;
